<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import NONAV from '@/layouts/no-nav.vue'
import DEFAULT from '@/layouts/default.vue'
import SIDENAV from '@/layouts/side-nav.vue'

const options = {
  NONAV,
  DEFAULT,
  SIDENAV
}

export default {
  name: 'layout-broker',
  props: {
    name: String
  },
  computed: {
    layout() {
      let component = options[this.name.toUpperCase().replace(/\W/g, '')]
      return component || NONAV
    }
  }
}
</script>
